import { useLocation } from "react-router-dom";
import { useSettings, buildWhatsAppLink, onWhatsAppClick } from "@/contexts/SettingsContext";
import WhatsAppIcon from "@/components/WhatsAppIcon";

export default function FloatingWhatsApp() {
  const { settings } = useSettings();
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;
  // Hide on project pages — the in-post "WhatsApp inquiry about this post" CTA
  // already covers the use-case AND carries the project URL automatically.
  // Avoids overlapping UI during expanded post view.
  if (location.pathname.startsWith("/project/")) return null;
  if (settings?.show_floating_whatsapp === false) return null;

  return (
    <a
      href={buildWhatsAppLink(settings?.whatsapp_number)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onWhatsAppClick}
      data-testid="floating-whatsapp-button"
      className="group fixed bottom-5 right-5 md:bottom-7 md:right-7 z-40"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366]/35 animate-ping [animation-duration:2.4s] pointer-events-none" aria-hidden="true" />
      <span className="relative flex items-center justify-center w-14 h-14 md:w-[62px] md:h-[62px] rounded-full bg-[#25D366] group-hover:bg-[#1FB855] text-white transition-all duration-300 shadow-[0_8px_28px_-6px_rgba(37,211,102,0.5),0_0_0_1px_rgba(255,255,255,0.06)] group-hover:shadow-[0_12px_36px_-8px_rgba(37,211,102,0.7)] group-hover:scale-[1.04]">
        <WhatsAppIcon className="w-7 h-7 md:w-[30px] md:h-[30px]" color="#FFFFFF" />
      </span>
    </a>
  );
}
